import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import { useSportConfiguration } from "~hooks/useSportConfiguration.ts";
import type { PersonResponse } from "~types/person.ts";
import type { SelectBaseMultipleProperties } from "~types/selectBaseMultipleProperties.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect/InfinitySelect";

type Props = SelectBaseMultipleProperties<InfinitySelectOption>;

export const SelectPersons = ({ value, onChange, ...props }: Props) => {
  const { sport, organizationId } = useParams();
  const sportConfiguration = useSportConfiguration();

  const onConvertResponseIntoOptionsHandler = (response: PersonResponse) =>
    (response?.data || []).map((x) => ({ label: x.nameFullLocal, value: x.personId }));

  return (
    <InfinitySelect<PersonResponse>
      {...props}
      url={`${sport}/o/${organizationId}/persons`}
      includes={["persons"]}
      searchParameter="nameFullLocalContains"
      sortByFieldName="nameFullLocal"
      maxCount={sportConfiguration.maxParticipantCount}
      values={value ? value : []}
      onChangeMultiple={onChange}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.PERSON}
      permissionOperation={PermissionOperations.READ}
    />
  );
};
